import React, { useState } from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page" style={{ backgroundColor: '#f4f6f8', paddingBottom: '6rem' }}>
      
      {/* INJECTED STYLES TO HIDE GLOBAL ARROWS */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .legal-hero::after {
            display: none !important;
          }
        `}
      </style>

      {/* Unified Hero */}
      <section className="legal-hero">
        <div className="container text-center">
          <h1>Privacy Policy</h1>
          <p className="subtitle">
            How Nightmark Protective Services handles and protects your data.
          </p>
        </div>
      </section>

      {/* Legal Content (Floating Document Card) */}
      <section className="legal-content container" style={{ position: 'relative', marginTop: '-80px', zIndex: 10 }}>
        <div className="legal-text-block" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 8%', borderRadius: '16px', boxShadow: '0 20px 50px rgba(0,0,0,0.08)' }}>
          
          <div style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', paddingBottom: '1.5rem', marginBottom: '3rem' }}>
            <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-grey)' }}>
              Last Updated: May 2026
            </p>
          </div>
          
          <h2>1. Introduction</h2>
          <p>
            Nightmark Protective Services ("we", "us" or "our") is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, process and protect your personal data in accordance with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
          </p>

          <h2>2. Information We Collect</h2>
          <p>We may collect and process the following data about you:</p>
          <ul className="legal-list">
            <li><strong>Identity Data:</strong> First name, last name, title and date of birth.</li>
            <li><strong>Contact Data:</strong> Billing address, email address and telephone numbers.</li>
            <li><strong>Operational Data:</strong> Information relating to the security services provided to you, including site layouts, risk assessments and access codes.</li>
            <li><strong>Technical Data:</strong> IP address, browser type and interaction with our website.</li>
            <li><strong>CCTV and Monitoring Data:</strong> Images and audio captured during the provision of our Live Remote Monitoring or Static Guarding services.</li>
          </ul>

          <h2>3. How We Use Your Data</h2>
          <p>We use your personal data to:</p>
          <ul className="legal-list">
            <li>Perform the contract we are about to enter into or have entered into with you.</li>
            <li>Comply with legal, regulatory and licensing obligations (including SIA and BS7858 vetting standards).</li>
            <li>Manage our relationship with you, including billing and customer support.</li>
            <li>Improve our website, services and operational deployments.</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We have implemented stringent security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorised way. Access to your personal data is restricted exclusively to employees, contractors and agents who have a strict operational "need to know" and are subject to severe confidentiality obligations.
          </p>

          <h2>5. Your Legal Rights</h2>
          <p>Under data protection laws, you have rights in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, to request data portability and (where the lawful ground of processing is consent) to withdraw consent.</p>

          <h2>6. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data protection practices, please contact our Data Protection Officer at: <a href="mailto:info@nightmarkprotectiveservices.com" style={{ fontWeight: '600' }}>info@nightmarkprotectiveservices.com</a>.
          </p>
        </div>
      </section>

    </div>
  );
};

export default PrivacyPolicy;